var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.652433,
    y: 0.33798,
    width: 41.0083,
    height: 41.0083,
    stroke: "#C71A33",
    strokeWidth: 0.67596
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_959_4468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8435 12.3833L10.3784 19.5407C9.63528 19.874 9.38395 20.5415 10.1988 20.9038L14.9359 22.417L26.3896 15.3018C27.015 14.8551 27.6552 14.9742 27.1043 15.4656L17.2671 24.4185L16.9581 28.2074C17.2443 28.7924 17.7683 28.7951 18.1026 28.5043L20.8242 25.9158L25.4854 29.4242C26.568 30.0685 27.1571 29.6527 27.39 28.4719L30.4473 13.9203C30.7648 12.4669 30.2235 11.8265 28.8435 12.3833Z",
    fill: "#C71A33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_959_4468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8421,
    height: 20.8421,
    fill: "white",
    transform: "translate(9.69336 10.5336)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramFooter);
export default __webpack_public_path__ + "static/media/telegramFooter.76470ef693b4479c55002884c870e523.svg";
export { ForwardRef as ReactComponent };